module.exports = __webpack_public_path__ + "img/组 7420.7fc57cfd.png";